import { createAsyncActions } from '~/utils/store';

export const SHOW = '@@DRAWER_PROSPECTIONS/SHOW';
export const CLOSE = '@@DRAWER_PROSPECTIONS/CLOSE';
export const SET_DATE = '@@PROSPECTIONS/SET_DATE';
export const SHOW_SUMMARY_DRAWER = '@@DRAWER_PROSPECTIONS/SHOW_SUMMARY';
export const CLOSE_SUMMARY_DRAWER = '@@DRAWER_PROSPECTIONS/CLOSE_SUMMARY';

export const CREATE = createAsyncActions('@@DRAWER_PROSPECTIONS/CREATE');
export const BATCH = createAsyncActions('@@DRAWER_PROSPECTIONS/BATCH');
export const SAVE = createAsyncActions('@@DRAWER_PROSPECTIONS/SAVE');
export const DELETE = createAsyncActions('@@DRAWER_PROSPECTIONS/DELETE');
export const BULK_DELETE = createAsyncActions('@@DRAWER_PROSPECTIONS/BULK_DELETE');

export const FETCHQTDD = createAsyncActions('@@PROSPECTIONS/FETCHQTDD');
export const MOVE = createAsyncActions('@@PROSPECTIONS/MOVE');
export const LOAD = createAsyncActions('@@PROSPECTIONS/LOAD');
export const LOAD_MORE_LEADS = createAsyncActions('@@PROSPECTIONS/LOAD_MORE_LEADS');
export const LOAD_CADENCE_SUMMARY = createAsyncActions('@@PROSPECTIONS/LOAD_CADENCE_SUMMARY');
export const LOAD_CADENCE_DETAILED_SUMMARY = createAsyncActions('@@PROSPECTIONS/LOAD_CADENCE_DETAILED_SUMMARY');
export const LOAD_SUMMARY_CARD_LEADS = createAsyncActions('@@PROSPECTIONS/LOAD_SUMMARY_CARD_LEADS');

export const show = (data = null) => ({
    type: SHOW,
    payload: {
        data
    }
});

export const close = () => ({
    type: CLOSE,
    payload: {}
});

export const create = (data) => ({
    type: CREATE.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2',
            data,
            showLoading: false
        }
      }
});

export const batch = (data) => ({
    type: BATCH.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2/batch',
            data,
            showLoading: false,
            suppressSuccessMessage: true
        }
      }
});

export const update = (id, data) => ({
    type: SAVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads_v2/${id}`,
            data,
            showLoading: false
        }
    }
});

export const remove = (lead) => ({
    type: DELETE.INIT,
    payload: {
        request:{
            method: 'delete',
            url:`/leads_v2/${lead.id}`
        },
        lead
    }
});

export const loadLeads = ({ ...params }) => ({
    type: LOAD.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads_v2?entity_type=prospecting${params.date ? `&date=${params.date}` : ''}`,
            ...params,
            showLoading: false
        }
    }
});

export const loadMoreLeads = ({ columnId, currentCount, moreCount }) => ({
    type: LOAD_MORE_LEADS.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads_v2/more?stage=${columnId}&current_count=${currentCount}&more_count=${moreCount}&entity_type=prospecting`,
            columnId
        },
    },
})

export const fetchQtddByMonth = ({ date }) => ({
    type: FETCHQTDD.INIT,
    payload: {
        request:{
            method: 'get',
            url:`/leads_v2/qtdd/${date}?entity_type=prospecting`
        }
    }
});

export const move = (props) => {
  const [sourceColumn, destColumn, droppableSource, droppableDestination, leadId] = props;
  
  // Check if destination is a step column
  const isStepColumn = destColumn && destColumn.id && destColumn.id.toString().startsWith('step_');
  
  if (isStepColumn) {
    // Extract step UID from column ID
    const stepUid = destColumn.id.replace('step_', '');
    
    // Update the lead's cadence data to mark this step as done and move to next
    return {
      type: MOVE.INIT,
      payload: {
        request: {
          method: 'put',
          url: `/leads_v2/${leadId}/update-cadence-step?entity_type=prospecting`,
          data: { 
            stepUid,
            action: 'complete_step'
          }
        },
      },
      props: props
    };
  } else {
    // Handle moves to base columns (Inicio, Positivo, Negativo)
    return {
      type: MOVE.INIT,
      payload: {
        request: {
          method: 'put',
          url: `/leads_v2/${leadId}/move?entity_type=prospecting`,
          data: { to: droppableDestination.droppableId }
        },
      },
      props: props
    };
  }
};

export const setDate = (date) => ({
    type: SET_DATE,
    payload: {
        date
    }
});

export const updateColumnsForCadence = (cadenceData) => ({
    type: 'UPDATE_COLUMNS_FOR_CADENCE',
    payload: {
        cadenceData
    }
});

export const bulkDelete = (leadIds) => ({
    type: BULK_DELETE.INIT,
    payload: {
        request:{
            method: 'delete',
            url:'/leads_v2/bulk-delete',
            data: { ids: leadIds }
        },
        showLoading: false,
        leadIds
    }
});

export const showSummaryDrawer = (summaryData) => ({
    type: SHOW_SUMMARY_DRAWER,
    payload: {
        summaryData
    }
});

export const closeSummaryDrawer = () => ({
    type: CLOSE_SUMMARY_DRAWER,
    payload: {}
});

export const loadCadenceSummary = () => ({
    type: LOAD_CADENCE_SUMMARY.INIT,
    payload: {
        request: {
            method: 'GET',
            url: '/leads_v2/cadence-summary?entity_type=prospecting',
            showLoading: false
        }
    }
});

export const loadCadenceDetailedSummary = (cadenceName, date) => ({
    type: LOAD_CADENCE_DETAILED_SUMMARY.INIT,
    payload: {
        request: {
            method: 'GET',
            url: '/leads_v2/cadence-detailed-summary?entity_type=prospecting' +
                (cadenceName ? '&cadence_name=' + encodeURIComponent(cadenceName) : '') +
                (date ? '&date=' + date : ''),
            showLoading: false
        }
    }
});

export const loadSummaryCardLeads = (cardType, cadenceName, date) => ({
    type: LOAD_SUMMARY_CARD_LEADS.INIT,
    payload: {
        request: {
            method: 'GET',
            url: '/leads_v2/summary-card-leads?entity_type=prospecting' +
                '&card_type=' + encodeURIComponent(cardType) +
                (cadenceName ? '&cadence_name=' + encodeURIComponent(cadenceName) : '') +
                (date ? '&date=' + date : ''),
            showLoading: false
        }
    }
});

